import { GoogleEvent } from '@app/googlecalendar'
import { useEffect } from 'react'
import { CalendarDisplayEvent } from './CalendarDisplayEvent'

export function getDateFromUnion(union: any) {
	let res = union.dateTime
	if (!res) res = union.date + 'T00:00:00'
	return new Date(res)
}
